import PromoCreate from './PromoCreate'
export {PromoCreate}
export default PromoCreate
